import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

//UI
import { Skeleton, Row, Col, Form } from "antd";
import { Input } from "../../../Common/Input";
import { ButtonPrimary, ButtonLink } from "../../../Common/Button";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import {
  HomePageHeader,
  HeaderRightItem,
  HeaderLeftItemsWrapper,
  HeaderRightItemsWrapper,
} from "../../../Common/UIElements";
import OnboardingPropertyDropdown from "../../PropertySelect/OnboardingPropertyDropdown";

const CorporateContactPropertyUsersTopBar = (props) => {
  const history = useHistory();

  const { updateSearchMeta, property, setProperty, addPropertyUser, customer } =
    props;

  return (
    <div className="corporate-contact-users-top-bar">
      <Skeleton loading={false} active>
        <HomePageHeader>
          <Col xxl={16} xl={16} lg={16} md={16} sm={24} xs={24}>
            <Form layout="vertical">
              <HeaderLeftItemsWrapper>
                <Col xxl={8} xl={8} lg={6} md={6} sm={24} xs={24}>
                  <Form.Item label="Property Name">
                    <OnboardingPropertyDropdown
                      setProperty={setProperty}
                      customer={customer}
                      property={property}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={6} md={6} sm={24} xs={24}>
                  <Form.Item label=" ">
                    <Input
                      name="searchAll"
                      className="onboarding-toolbar-input"
                      prefix={<SearchOutlined />}
                      onChange={(e) => {
                        updateSearchMeta(e.target.value, "searchAll");
                      }}
                      placeholder="Search"
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </HeaderLeftItemsWrapper>
            </Form>
          </Col>
          <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
            <HeaderRightItemsWrapper>
              <HeaderRightItem>
                <ButtonLink
                  onClick={addPropertyUser}
                  size="large"
                  icon={<PlusOutlined />}
                >
                  Add Property Contact User
                </ButtonLink>
              </HeaderRightItem>
              <HeaderRightItem>
                <ButtonPrimary
                  onClick={() => {
                    history.push("/onboarding/dashboard");
                  }}
                >
                  Back to Dashboard
                </ButtonPrimary>
              </HeaderRightItem>
            </HeaderRightItemsWrapper>
          </Col>
        </HomePageHeader>
      </Skeleton>
    </div>
  );
};

export default CorporateContactPropertyUsersTopBar;
